var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout layout--full"},[_c('div',{staticClass:"layout--content--container"},[_c('header',{staticClass:"layout--header"},[_vm._t("header")],2),_c('div',{staticClass:"layout--content"},[_vm._t("content")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }